module.exports = __webpack_public_path__ + "static/img/f-1.cc9f929a.png";